var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"layout"},[(!_vm.isCompanyPage)?_c('page-breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}):_vm._e(),_c('layout-placeholder',{attrs:{"blocks":_vm.content,"externalData":_vm.externalData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }